export default { sha: 'fdc79448bd2598dfb5f7710faccd3557a99352ee', buildNumber: 'undefined' }
